import React from "react";
import './styles/landing.css';
import {useNavigate} from "react-router-dom";

const Features = (props) => {
  // const navigate = useNavigate();
 
  const allFeatures = props.data ? [...props.data.slice(0, 6)] : [];
  
 
  // allFeatures.push({
  //   title: "Valisasi SMKHP",
  //   text: "Validasi SMKHP untuk memastikan keabsahan dokumen dan informasi terkait.",
  //   icon: "path/to/icon-manual.png",
  //   link: "/val-smkhp"  
  // });

  return (
    <section id="features" className="features-section mt-80">
      <div className="container-fluid mt-40">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2>FITUR LAYANAN</h2>
          <h3 className="group-title">Sistem Pelayanan Pengguna Jasa</h3>
        </div>


        <div className="slider-container">
          <div className="slider-track">
            <div className="slider-group">
              {allFeatures.map((d, i) => (
                <a key={`orig-${i}`} href={d.link} target="_blank" rel="noopener noreferrer" className="feature-card-horizontal">
                  <div className="icon-circle">
                    <img src={d.icon} alt={d.title} onError={(e) => { e.target.style.display = 'none'; }} />
                  </div>
                  <div className="card-content">
                    <h4>{d.title}</h4>
                    <p>{d.text}</p>
                  </div>
                </a>
              ))}
            </div>

         
            <div className="slider-group" aria-hidden="true">
              {allFeatures.map((d, i) => (
                <a key={`dup-${i}`} href={d.link} target="_blank" rel="noopener noreferrer" className="feature-card-horizontal">
                  <div className="icon-circle">
                    <img src={d.icon} alt={d.title} onError={(e) => { e.target.style.display = 'none'; }} />
                  </div>
                  <div className="card-content">
                    <h4>{d.title}</h4>
                    <p>{d.text}</p>
                  </div>
                </a>
              ))}
            </div>

          </div>
        </div>

        {!props.data && <p className="text-center text-muted mt-4">Loading...</p>}
      </div>
    </section>
  );
};

export default Features;